import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldTextInput,
  NamedLink,
  ReactCurvedText,
} from '../../../components';
import lightingPic from '../../../components/Topbar/TopbarDesktop/gateImages/cropped/Interiors-light-crop.jpg';
import RotatingButton from '../../../components/RotatingButton/RotatingButton';

import css from './LoginForm.module.css';

const LoginFormComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        intl,
        invalid,
        horizontalTab,
        loginOrSignupError,
      } = fieldRenderProps;

      // email
      const emailLabel = intl.formatMessage({
        id: 'LoginForm.emailLabel',
      });
      const emailPlaceholder = intl.formatMessage({
        id: 'LoginForm.emailPlaceholder',
      });
      const emailRequiredMessage = intl.formatMessage({
        id: 'LoginForm.emailRequired',
      });
      const emailRequired = validators.required(emailRequiredMessage);
      const emailInvalidMessage = intl.formatMessage({
        id: 'LoginForm.emailInvalid',
      });
      const emailValid = validators.emailFormatValid(emailInvalidMessage);

      // password
      const passwordLabel = intl.formatMessage({
        id: 'LoginForm.passwordLabel',
      });
      const passwordPlaceholder = intl.formatMessage({
        id: 'LoginForm.passwordPlaceholder',
      });
      const passwordRequiredMessage = intl.formatMessage({
        id: 'LoginForm.passwordRequired',
      });
      const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress;

      const passwordRecoveryLink = (
        <NamedLink name="PasswordRecoveryPage" className={css.recoveryLink}>
          <FormattedMessage id="LoginForm.forgotPassword" />
        </NamedLink>
      );

      const handleOnClickLogin = () => {
        if (!submitDisabled) {
          handleSubmit();
        }
      };

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div className={css.wrapper}>
            <aside className={css.fixedAsideWrapper}>
              <img src={lightingPic} className={css.asideImage} />
            </aside>
            <div className={css.formWrapper}>
              {loginOrSignupError &&
                <label style={{ whiteSpace: 'pre-line' }}>{loginOrSignupError}</label>
              }
              {horizontalTab}
              <FieldTextInput
                className={css.textField}
                type="email"
                id={formId ? `${formId}.email` : 'email'}
                name="email"
                autoComplete="email"
                label={emailLabel}
                // placeholder={emailPlaceholder}
                validate={validators.composeValidators(emailRequired, emailValid)}
              />
              <FieldTextInput
                className={css.textField}
                type="password"
                id={formId ? `${formId}.password` : 'password'}
                name="password"
                autoComplete="current-password"
                label={passwordLabel}
                // placeholder={passwordPlaceholder}
                validate={passwordRequired}
              />

              <div className={css.tcWrapper}>
                <p className={css.bottomWrapperText}>
                  <span className={css.recoveryLinkInfo}>
                    <FormattedMessage
                      id="LoginForm.forgotPasswordInfo"
                      values={{ passwordRecoveryLink }}
                    />
                  </span>
                </p>
              </div>

              <div className={css.submitButtonWrapper}>
                <RotatingButton
                  type="submit"
                  label={'ENTER YOUR ROTATE ROOM · ENTER YOUR ROTATE ROOM ·'}
                  inProgress={submitInProgress}
                  disabled={submitDisabled}
                  customStyles={{ fontSize: '18px' }}

                // ready={submitReady}
                // successMessage={'Added to the rotation'}
                />
              </div>
            </div>
          </div>
        </Form>
      );
    }}
  />
);

LoginFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  form: null,
  inProgress: false,
};

const { string, bool } = PropTypes;

LoginFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  form: string,
  inProgress: bool,
  intl: intlShape.isRequired,
};

const LoginForm = compose(injectIntl)(LoginFormComponent);
LoginForm.displayName = 'LoginForm';

export default LoginForm;
